import { func, object } from 'prop-types';
import React, { useCallback, useState } from 'react';
import { connect, useSelector } from 'react-redux';

import ModalComponent from '@components/Share/ModalComponent';

import { usePickupFromStoreContext } from '../PickupFromStoreContext';
import StoreFilter from './StoreFilter';

const AvailabilityStoresListModal = ({ addressSelected, onCloseHandler, ...props }) => {
  const { storesList, selectStoreButtonLabel, onStoreSelect } = usePickupFromStoreContext();
  const settingGlobal = useSelector((state) => state.settingGlobalReducer.settingGlobal);
  const [storeItemSelected, setStoreItemSelected] = useState(null);

  const handleClickOnStoreItem = useCallback((storeItemData) => setStoreItemSelected(storeItemData), []);

  const handleSelectStore = useCallback(() => {
    if (onStoreSelect) {
      onStoreSelect(storeItemSelected);
      if (onCloseHandler) onCloseHandler();
    }
  }, [storeItemSelected, onStoreSelect, onCloseHandler]);

  return (
    <ModalComponent {...props} onCloseHandler={onCloseHandler} cssClass={onStoreSelect ? 'pfs-modal' : 'pickup-from-store-modal'}
    >
      <h3
        className={onStoreSelect
          ? 'pfs-modal__title'
          : 'pickup-from-store-modal__title'}
      >{settingGlobal?.['BOPISPopupTitle']}</h3>
      <p
        className={onStoreSelect
          ? 'pfs-modal__description'
          : 'pickup-from-store-modal__description'}
      >{settingGlobal?.['BOPISPopupDescription']}</p>
      <StoreFilter />
      {storesList.length ? (
        <>
          <ul className={onStoreSelect ? 'pfs-modal__stores-list' : 'pickup-from-store-modal__list'}>
            {storesList.map((store) => (
              <li
                key={store.OutletId}
                className={
                  onStoreSelect
                    ? [
                      'pfs-modal__stores-list-item',
                      storeItemSelected?.OutletId === store?.OutletId ? 'active' : '',
                      addressSelected?.PickUpStoreId === store?.OutletId ? 'selected active' : ''
                    ].join(' ')
                    : 'pickup-from-store-modal__list-item'}
                onClick={() => handleClickOnStoreItem(store)}
              >
                <h6 className='store-name'>{store.Name}</h6>
                <p className='store-stock'>{settingGlobal?.['InStockText']}</p>
                <div className='store-info'>
                  <p>{store.FullAddress}</p>
                  <p>{store.Postcode}</p>
                  <a href={`tel:${store.Phone}`}>{store.Phone}</a>
                </div>
              </li>
            ))}
          </ul>
          {onStoreSelect ? (
            <div className='my-address__btn text-center'>
              <button className='btn btn-outline-primary' onClick={handleSelectStore}>
                {selectStoreButtonLabel}
              </button>
            </div>
          ) : (
            <></>
          )}
        </>
      ) : (
        <p className='pickup-from-store-modal__store-filter-empty'>{settingGlobal?.['StoreFilterNotFound']}</p>
      )}
    </ModalComponent>
  );
};

AvailabilityStoresListModal.propTypes = {
  addressSelected: object,
  onCloseHandler: func
};

const mapStateToProps = (state) => {
  const currentCustomCart = state.productReducer.cartDetailReducer.currentCartCustom || null;
  const clientSOCartCustomData = state.personalizeOfferReducer.getClientSOCartReducer.customData || null;

  return {
    addressSelected: (
      clientSOCartCustomData || currentCustomCart
    )?.PickUpStore?.[0]?.Address
  };
};

export default connect(mapStateToProps)(AvailabilityStoresListModal);